module.exports = __webpack_public_path__ + "static/media/imdb.f7f2904f.png";